import { createReducer, on } from '@ngrx/store';

import { moneyInOutAction } from './money-in-out.actions';

export const moneyInOutKey = 'money-in-out';

export interface MoneyInOutState {
  moneyInOutList: any;
  moneyInOutDetail: any;
}

export const initialState: MoneyInOutState = {
  moneyInOutList: null,
  moneyInOutDetail: null
};

export const moneyInOutReducer = createReducer<MoneyInOutState>(
  initialState,
  on(moneyInOutAction.moneyInOutListResponse, (state, response) => {
    return { ...state, moneyInOutList: response.response };
  }),
  on(moneyInOutAction.viewMoneyInOutResponse, (state, response) => {
    return { ...state, moneyInOutDetail: response.response };
  })
);
